/**
 * This script automatically initializes bootstrap tooltips on hover. Allows
 * you to create/add new tooltipped elements to the page without the need for
 * re-initialization of all tooltips. Also, if a tooltipped element is never
 * hovered over - its tooltip is never initialized
 *
 * USAGE: automatic
 *
 * DEPENDENCIES:
 *  - jQuery
 *  - bootstrap-tooltip
 */
(function ($) {
    "use strict";

    // Set defaults
    $.fn.tooltip.Constructor.DEFAULTS.placement = 'right auto';
    $.fn.tooltip.Constructor.DEFAULTS.trigger   = 'hover focus click';

    // Initialize
    $(document).on('mouseenter touchstart', '[data-toggle="tooltip"]', function () {
        var $this = $(this);

        if (!$this.data('bs.tooltip')) {
            $this.tooltip('show');
        }
    });

    // Hide tooltips on clicks outside the tooltip elements on mobile
    $(document).on('touchstart', function (event) {
        var $target  = $(event.target),
            $tooltip = $target.closest('[data-toggle="tooltip"]');

        $('[data-toggle="tooltip"]').each(function () {
            var $this = $(this);

            if (!$this.data('bs.tooltip') || $this.is($tooltip)) return;
            $this.tooltip('hide');
        });
    });
})(window.jQuery);
